class CalendarEvent {
    repeats: boolean;

    constructor(repeats: boolean) {
        this.repeats = repeats;
    }

    occurances(firstDate: Date, lastDate: Date): number {
        throw new Error("Method 'say()' must be implemented.");
    }
};

export { CalendarEvent };